import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from "@mui/material";
import React from "react";

type Props = {
  name: string;
  tel: string;
};
export const TakeoutCustomerTable = React.memo<Props>(({name, tel}) => {
  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>氏名</TableCell>
            <TableCell>電話番号</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{name}</TableCell>
            <TableCell>{tel}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
});
